export enum AttributeIdentifiers {
  MIN_VALUE = 'minValue',
  MAX_VALUE = 'maxValue',
  MIN_VALUE_SINGLE = 'minValueSingle',
  MIN_VALUE_DOUBLE = 'minValueDouble',
  MAX_VALUE_SINGLE = 'maxValueSingle',
  MAX_VALUE_DOUBLE = 'maxValueDouble',
  STEP = 'steps',
}
